import { __ } from '@wordpress/i18n';
import { InnerBlocks } from '@wordpress/block-editor';

export default function save(props) {
    const { attributes } = props;


    return (
        <>
            <div id={'id-' + attributes.blockId}>

                <div className='swiper-wrapper'>
                    <InnerBlocks.Content />
                </div>
            </div>
        </>

    );


}
